"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureEntryPageResource = exports.defaultConfig = void 0;
const resources_1 = require("@opentelemetry/resources");
exports.defaultConfig = {
    path: true,
    hash: true,
    hostname: true,
    referrer: true,
    url: false,
    search: false,
};
function configureEntryPageResource(config) {
    if (config === false || !(window === null || window === void 0 ? void 0 : window.location)) {
        return new resources_1.Resource({});
    }
    const options = getOptions(config);
    const { href, pathname, search, hash, hostname } = window.location;
    const attributes = {
        'entry_page.url': optionalAttribute(options.url, href),
        'entry_page.path': optionalAttribute(options.path, pathname),
        'entry_page.search': optionalAttribute(options.search, search),
        'entry_page.hash': optionalAttribute(options.hash, hash),
        'entry_page.hostname': optionalAttribute(options.hostname, hostname),
        'entry_page.referrer': optionalAttribute(options.referrer, document.referrer),
    };
    return new resources_1.Resource(attributes);
}
exports.configureEntryPageResource = configureEntryPageResource;
function getOptions(config) {
    if (!config) {
        return exports.defaultConfig;
    }
    return Object.assign(Object.assign({}, exports.defaultConfig), config);
}
function optionalAttribute(shouldInclude, attribute) {
    if (!shouldInclude) {
        return undefined;
    }
    return attribute;
}
